export default "__VITE_ASSET__BFTeHvRF__"